import Login from "./pages/login/Login";
import Signup from "./pages/Signup";
import React, {ReactNode} from "react";
import Dashboard from "./pages/dashboard/Dashboard";
import Templates from "./pages/templates/Templates";
import Checkouts from "./pages/checkouts/Checkouts";
import Messages from "./pages/messages/Messages";
import Orders from "./pages/orders/Orders";
import Reports from "./pages/reports/Reports";
import Profile from "./pages/profile/Profile";
import SiteSettings from "./pages/siteSettings/SiteSettings";
import WhatsappPricing from "./pages/whatsappPricing/WhatsappPricing";
import Docs from "./pages/docs/Docs";
import Conversations from "./pages/conversations/Conversations";
import Flows from "./pages/flows/Flows";
import Flow from "./pages/flows/Flow";
import AfterCapUpdate from "./pages/afterCapUpdate/AfterCapUpdate";
import Campaigns from "./pages/campaigns/Campaigns";
import Customers from "./pages/customers/Customers";
import Segments from "./pages/segments/Segments";
import CampaignInsights from "./pages/campaignInsights/CampaignInsights";
import LoginNext from "./pages/login/LoginNext";
import MobileSettings from "./pages/mobileSettings/MobileSettings";
import SelectShop from "./SelectShop";
import Touchpoints from "./pages/widgets/Widgets";
import AutomationEditor from "./pages/automations/AutomationEditor";
import AutomationEditorPage from "./pages/automations/AutomationEditorPage";
import AutomationsListPage from "./pages/automations/AutomationsListPage";
import AutomationTreeEditorPage from "./pages/automations/AutomationTreeEditorPage";
import AutomationTreeCreatePage from "./pages/automations/AutomationTreeCreatePage";
import V2OnboardingAgentPage from "./pages/onboarding/V2OnboardingAgentPage";
import TemplateBuilderPage from "./pages/templates/v2/TemplateBuilderPage";
import TemplatesV2Page from "./pages/templates/v2/TemplatesV2Page";
import V2CopilotPage from "./pages/copilot/V2CopilotPage";
import KnowledgeBasePage from "./pages/knowledgeBase/KnowledgeBasePage";
import {SupportWidgetPanel} from "./pages/widgets/supportWidget/SupportWidgetPanel";

interface VuelveRoute {
    path: string;
    element: ReactNode | ReactNode[];
}

export const UserRoutes: VuelveRoute[] = [
    { path: '', element: <Dashboard /> },
    { path: 'dashboard', element: <Dashboard /> },
    // { path: 'templates', element: <Templates /> },
    { path: 'automations', element: <Flows /> },
    { path: 'automation/:id', element: <Flow /> },
    { path: 'campaigns', element: <Campaigns /> },
    { path: 'checkouts', element: <Checkouts /> },
    { path: 'messages', element: <Messages /> },
    { path: 'orders', element: <Orders /> },
    { path: 'reports', element: <Reports /> },
    { path: 'profile', element: <Profile /> },
    { path: 'settings', element: <SiteSettings /> },
    { path: 'mobile-settings', element: <MobileSettings /> },
    { path: 'docs', element: <Docs /> },
    { path: 'conversations', element: <Conversations /> },
    { path: 'customers', element: <Customers /> },
    { path: 'audience', element: <Segments /> },
    { path: 'campaigns-insights', element: <CampaignInsights /> },
    { path: 'select-shop', element: <SelectShop /> },
    { path: 'widgets', element: <Touchpoints /> },
    { path: 'widgets/support', element: <SupportWidgetPanel /> },
    { path: 'automations-pro', element: <AutomationsListPage /> },
    { path: 'automations-pro/new', element: <AutomationTreeCreatePage /> },
    { path: 'automations-pro/:automationId', element: <AutomationEditorPage mode="edit" /> },
    { path: 'automations-pro/:automationId/tree', element: <AutomationTreeEditorPage /> },
    { path: "/templates/new", element: <TemplateBuilderPage /> },
    { path: "/templates/v2/:id/edit", element: <TemplateBuilderPage /> },
    { path: "/templates/v2", element: <TemplatesV2Page /> },
    { path: "/vivo", element: <V2CopilotPage /> },
    { path: "/knowledge-base", element: <KnowledgeBasePage /> }

];

export const GuestRoutes: VuelveRoute[] = [
    { path: 'login', element: <LoginNext /> },
    { path: 'signup', element: <Signup /> },
    { path: 'start', element: <V2OnboardingAgentPage /> },
    { path: 'whatsapp-pricing', element: <WhatsappPricing /> },
    { path: 'after-cap-update', element: <AfterCapUpdate />},
];
